import {h} from 'ui/Framework';

export default h('svg', {
  width: '44',
  height: '21',
  viewBox: '-1 -1 46 23',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', {
      fill: '#21304A'
    }, [
      h('g', [
        h('path', {
          d: 'M7.304 20.496H5.288V3.164L1.704 6.216l-1.232-1.4L5.512.672h1.792v19.824zm20.328 0H14.948v-2.1l8.12-8.204c.299-.299.593-.62.882-.966.29-.345.546-.705.77-1.078.224-.373.401-.77.532-1.19.13-.42.196-.854.196-1.302 0-.579-.103-1.101-.308-1.568a3.436 3.436 0 0 0-.854-1.19 3.91 3.91 0 0 0-1.26-.756 4.256 4.256 0 0 0-1.498-.266c-1.064 0-1.96.331-2.688.994-.728.663-1.195 1.507-1.4 2.534l-1.988-.392c.13-.69.378-1.335.742-1.932a5.92 5.92 0 0 1 1.344-1.54A6.21 6.21 0 0 1 19.344.532a6.384 6.384 0 0 1 2.184-.364c.803 0 1.563.117 2.282.35a5.549 5.549 0 0 1 1.89 1.036 5.072 5.072 0 0 1 1.302 1.708c.327.681.49 1.47.49 2.366 0 .635-.089 1.223-.266 1.764a7.646 7.646 0 0 1-.7 1.54 8.98 8.98 0 0 1-1.022 1.386c-.392.439-.803.873-1.232 1.302l-7.14 7.084h10.5v1.792zm8.12-11.256h.868a7.87 7.87 0 0 0 1.792-.196c.56-.13 1.05-.34 1.47-.63.42-.29.751-.667.994-1.134.243-.467.364-1.027.364-1.68 0-.56-.103-1.069-.308-1.526a3.47 3.47 0 0 0-.854-1.176 3.91 3.91 0 0 0-1.26-.756 4.256 4.256 0 0 0-1.498-.266c-.84 0-1.582.196-2.226.588-.644.392-1.162.97-1.554 1.736l-1.708-.896c.616-1.064 1.4-1.853 2.352-2.366.952-.513 2.035-.77 3.248-.77.784 0 1.526.117 2.226.35.7.233 1.316.574 1.848 1.022a4.777 4.777 0 0 1 1.26 1.666c.308.663.462 1.423.462 2.282 0 1.176-.327 2.16-.98 2.954a4.66 4.66 0 0 1-2.464 1.582v.056a5.208 5.208 0 0 1 2.856 1.638c.765.85 1.148 1.946 1.148 3.29 0 .952-.173 1.797-.518 2.534a5.712 5.712 0 0 1-1.386 1.876 6.009 6.009 0 0 1-2.03 1.176 7.374 7.374 0 0 1-2.45.406c-1.456 0-2.725-.35-3.808-1.05-1.083-.7-1.904-1.703-2.464-3.01l1.904-.7c.336.952.896 1.694 1.68 2.226.784.532 1.68.798 2.688.798.56 0 1.106-.098 1.638-.294a4.244 4.244 0 0 0 1.4-.84c.401-.364.723-.807.966-1.33s.364-1.12.364-1.792c0-.747-.145-1.377-.434-1.89a3.545 3.545 0 0 0-1.162-1.246 5.024 5.024 0 0 0-1.652-.686 8.565 8.565 0 0 0-1.904-.21h-.868V9.24z'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/field-number.es6.js